import { action } from 'satcheljs/lib/legacy';
import store from '../store/store';
import sendTxpUserSettingsAction from '../utils/sendTxpUserSettingsAction';

export default action('initTxpSettings')(async function initTxpSettings() {
    if (store.txpSettings) {
        // If we already have the txp settings, we won't get it again
        return;
    }

    sendTxpUserSettingsAction();
});
